import { Button, Grid, Link, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "80px",
  background: "#FFF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "56px 16px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  flexDirection: props?.cardNumber == 1 ? "row" : "row-reverse",
  alignItems: "center",
  gap: "64px",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: "24px",
    alignItems: "flex-start",
    // maxWidth: "590px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    gap: "16px",
    alignItems: "flex-start",
  },
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  justifyContent: "center",
  width: "100%",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
    // maxWidth: "392px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "none",
    alignItems: "flex-start",
    width: "100%",
    textAlign: "left",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  textAlign: "center",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  alignSelf: "stretch",
  maxWidth: "950px",
  margin: "0 auto",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22.4px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  maxWidth: "1200px",
  alignItems: "flex-start",
  gap: "48px",
  flexDirection: "column",
  justifyContent: "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "48px",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "500px",
  maxWidth: "500px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "328px",
    maxWidth: "328px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "24px",

  [props.theme.breakpoints.down("lg")]: {
    // alignItems: "center",
    // textAlign: "center",
    alignItems: "flex-start",
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "24px",
    alignItems: "flex-start",
    textAlign: "left",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "20px" : "36px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 600,
  lineHeight: props.type == "desc" ? "30px" : "43.2px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.054px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const LinkStyled = styling(Link)((props) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "row",
  gap: "5px",
  color: "#512ACC",
  fontSize: "16px",
  fontWeight: "700",
  textDecoration: "none",
  lineHeight: "24px",
  letterSpacing: "0.15px",
  alignItems: "center",

  "&:hover": {
    color: "#40249B",
  },
}));
